/**
 * Icon registry — maps config icon keys to Lucide components.
 * Keeps configuration data free of React imports.
 */
import {
  Activity,
  Bolt,
  Bot,
  Box,
  Boxes,
  BrainCircuit,
  Cable,
  CheckCircle2,
  CircuitBoard,
  ClipboardList,
  Code2,
  Cpu,
  Factory,
  FlaskConical,
  Gauge,
  Hammer,
  LayoutDashboard,
  LineChart,
  Monitor,
  Network,
  PanelTop,
  Radio,
  ScanEye,
  Server,
  Wrench,
  Zap,
} from "lucide-react";

export const ICONS = {
  Activity,
  Bolt,
  Bot,
  Box,
  Boxes,
  BrainCircuit,
  Cable,
  CheckCircle2,
  CircuitBoard,
  ClipboardList,
  Code2,
  Cpu,
  Factory,
  FlaskConical,
  Gauge,
  Hammer,
  LayoutDashboard,
  LineChart,
  Monitor,
  Network,
  PanelTop,
  Radio,
  ScanEye,
  Server,
  Wrench,
  Zap,
};

export function resolveIcon(name, fallback = Factory) {
  return ICONS[name] || fallback;
}
